module.exports = __webpack_public_path__ + "img/4.686495ac.jpg";